import BaseRepository from "./BaseRepository";
import ProductDetailAPICall from "../service/ProductDetailAPICall";
import ProductListingAPICall from "../service/ProductListingAPICall";
import ProductListing from "../model/ProductListing";
import ProductInventoryRepository from "./ProductInventoryRepository";
import ProductPricingRepository from "./ProductPricingRepository";
import _, { isArray, isObject, isString } from 'underscore';
import storeInUse from "src/storeWire";
import produceClone from "../helper/produceClone";

import Helper from "src/support/Helper";
import ProductPricingAPICall from "src/service/ProductPricingAPICall";

class ProductRepository extends BaseRepository {

    attachProductAndInventoryToAnyObjectNew = async (objectInput, force_refresh = false, with_assets = true, isPriceCall = true) => {
        if (_.isArray(objectInput) && objectInput.length > 0) {
            let objectInputHere = [];
            objectInput.map((v) => {
                let v_h;
                if (v.ERPPartNumber === undefined) {
                    v_h = {
                        ERPPartNumber: v.partNumber
                    };
                } else {
                    v_h = {
                        ERPPartNumber: v.ERPPartNumber
                    }
                }
                objectInputHere.push(v_h);
            });
            let p_w_a = await this.fetchProductObjectByERPPartNumbersNew(objectInputHere, with_assets, force_refresh, isPriceCall);
            objectInput.map((v, i) => {
                let h = { ...v };
                if (v.ERPPartNumber !== undefined &&
                    v.ERPPartNumber &&
                    p_w_a && p_w_a[v.ERPPartNumber] !== undefined) {
                    h.product = p_w_a[v.ERPPartNumber]
                }
                if (v.ERPPartNumber === undefined) {
                    if (v.partNumber !== undefined &&
                        v.partNumber &&
                        p_w_a && p_w_a[v.partNumber] !== undefined) {
                        h.product = p_w_a[v.partNumber]
                    }
                }
                objectInput[i] = h;
            });
            return objectInput;
        }
        if (_.isObject(objectInput) && Object.entries(objectInput).length > 0) {
            let objectInputHere = [];
            Object.entries(objectInput).map((v) => {
                let v_h = {
                    ERPPartNumber: v[1].ERPPartNumber
                };
                objectInputHere.push(v_h);
            });

            let p_w_a = await this.fetchProductObjectByERPPartNumbersNew(objectInputHere, with_assets, force_refresh, isPriceCall);
            let objectInputRes = [];
            await Promise.all(Object.entries(objectInput).map((v, i) => {
                let h = { ...v[1] };
                if (v[1].ERPPartNumber !== undefined &&
                    v[1].ERPPartNumber &&
                    p_w_a && p_w_a[v[1].ERPPartNumber] !== undefined) {
                    h.product = p_w_a[v[1].ERPPartNumber]
                } else {
                    h.product = {
                        assets: {
                            inventory: {},
                            pricing: {}
                        }
                    }
                }
                objectInputRes.push({
                    k: v[0],
                    v: h
                });
            }));
            if (objectInputRes.length > 0) {
                let r = {};
                objectInputRes.map(v => {
                    r[v.k] = v.v;
                });
                return r;
            }
        }

        return objectInput;
    };
    /**
    * isPriceInventoryCall is used for reduce price and inventory call if it's false then not calling API
    * Author: Devanshi Patel
    */

    fetchProductObjectByERPPartNumbersNew = async (ERPPartNumbers, WithAssets = false, force_refresh = false, isPriceCall = true, searchCPN = '') => {
        let products = new ProductListing().toObjectWithERPPartNumber(
            await new ProductDetailAPICall().getProductDetail(ERPPartNumbers, false),
            ERPPartNumbers
        );

        if (WithAssets === false) {
            return products;
        }
        products = produceClone(products);

        if (searchCPN) {
            let selectedSearchCPN = await this.checkCPNAvailableInList(products[ERPPartNumbers].CustomerPartNumbers, searchCPN);
            products[ERPPartNumbers].customerPartNumber = selectedSearchCPN
        }

        // if (isObject(ERPPartNumbers) && Object.entries(ERPPartNumbers).length > 0) {
        //     Object.entries(ERPPartNumbers).map((v_l) => {
        //         let v = v_l[1];
        //     })
        // }

        let inventory = {}
        let pricing = {};

        // DT - 13141 - 14/8/23 - Inventory and price calls are made sequentially instead of parallel
        // inventory = await new ProductInventoryRepository().fetchProductInventoryByProducts(products, force_refresh);
        // if (isPriceCall)
        //     pricing = await new ProductPricingRepository().fetchProductPricingByProductsNew(products, force_refresh, inventory);
        await Promise.all([
            new ProductInventoryRepository().fetchProductInventoryByProducts(products, force_refresh),
            new ProductPricingRepository().fetchProductPricingByProductsNew(products, force_refresh)
        ]).then((res) => {
            inventory = res[0];
            pricing = res[1];
        }).catch(() => { });

        return new ProductListing().attachInventoryAndPricingToProductObjectNew(products,
            {
                inventory,
                pricing
            }
        );
    };


    fetchProductObjectByItemNumbers = async (ERPPartNumbers) => {
        return await new ProductDetailAPICall().getProductDetailByItemNumber(ERPPartNumbers, false);
    };
    fetchProductsObjectBySearchParam = async (search, limit = false, skipURLParams = false, isUniversalSearch = false) => {
        return new ProductListing().toObjectWithERPPartNumber(
            await new ProductListingAPICall().getList(false, limit, {
                search,
                isSkipFacets: true,
                skipURLParams: skipURLParams,
                universalSearch: isUniversalSearch
            }, null, true)
        );
    };

    // Need to remove
    fetchManufacturersBySearchParam = async (search) => {
        let res = await new ProductListingAPICall().getManufacturersListBySearchParam(search);
        try {
            return res['@search.facets']['ManufacturerName']['ManufacturerName'];
        } catch (e) {
            return [];
        }
    };
    // Need to remove
    fetchCategoriesBySearchParam = async (search) => {
        let res = await new ProductListingAPICall().getCategoriesListBySearchParam(search);
        try {
            return res['@search.facets']['Categories']['Categories'];
        } catch (e) {
            return [];
        }
    };

     // Need to remove
    fetchDocumentsBySearchParam = async (search) => {
        let res = await new ProductListingAPICall().getDocumentsListBySearchParam(search);
        try {
            return res['@search.facets']['Documents']['Documents'];
        } catch (e) {
            return [];
        }
    };

    fetchGroupedProductsObjectBySearchParam = async (search, ManufacturerName = false, ERPPartNumbers = false, onlyGroup = false) => {
        let res = new ProductListing().toGroupedObjectWithERPPartNumber(
            await new ProductListingAPICall().getGroupList(search, ManufacturerName, ERPPartNumbers, onlyGroup)
        );
        if (isArray(res) && res.length > 0) {
            res.map((v, i) => {
                if (v.Count === 1 && !v.ERPPartNumber && v.ItemNumber !== undefined && v.ItemNumber) {
                    res[i].ERPPartNumber = v.ItemNumber;
                }
                if (v.Count === 1 && !res[i].ERPPartNumber) {
                    delete res[i];
                }
            });
        }
        if (onlyGroup === true && isArray(res) && res.length > 0) {
            let g = [];
            res.map((v, i) => {
                if (v.Count === 1) {
                    g[i] = v
                }
            });
            return await new ProductRepository().attachProductAndInventoryToAnyObjectNew(g);
        }

        return res
    };
    fetchProductInventoryObjectByProducts = async (Products) => {
        return await new ProductInventoryRepository().fetchProductInventoryByProducts(Products);
    };
    fetchProductPricingObjectByProducts = async (Products) => {
        return await new ProductPricingRepository().fetchProductPricingByProductsNew(Products);
    };

    getProductDocumentImageList = async (filter, top, variantAssetSearchType, Orderby = '') => {
        return await new ProductDetailAPICall().getProductDocumentImageList({
            filter,
            top,
            variantAssetSearchType,
            Orderby
        });
    };

     // Need to remove
    getObsoleteFlagByERPPartNumberFromMasterStorage = async (ERPPartNumber) => {
        let res = await this.getMasterStorageDataByERPPartNumberFromMasterStorage(ERPPartNumber);
        if (res.ObsoleteFlag !== undefined) {
            return res.ObsoleteFlag;
        }
        return false;
    };

    getWebCodeFlagByERPPartNumberFromMasterStorage = async (ERPPartNumber) => {
        let res = await this.getMasterStorageDataByERPPartNumberFromMasterStorage(ERPPartNumber);
        if (res.WebCode !== undefined) {
            return res.WebCode;
        }
        return "";
    };

    getERPPartNumberModifiedByERPPartNumberFromMasterStorage = async (ERPPartNumber, withObject = false) => {
        let res = await this.getMasterStorageDataByERPPartNumberFromMasterStorage(ERPPartNumber);
        if (res.ERPPartNumberModified !== undefined) {
            if (withObject === true) {
                return res;
            }
            return res.ERPPartNumberModified;
        }
        return false;
    };

    getMasterStorageDataByERPPartNumberFromMasterStorage = async (ERPPartNumber) => {
        let storeIn = await storeInUse.getState();
        let master_data = {};
        try {
            master_data = storeIn.entities.model_ProductListing.master_data_only_products_list;
        } catch (e) {
            return {};
        }
        try {
            if (master_data[ERPPartNumber] !== undefined) {
                return master_data[ERPPartNumber];
            }
        } catch (e) {
            return {};
        }
        return {};
    };

    getProductDocumentCount = async (filter) => {
        return await new ProductDetailAPICall().getProductDocumentCount(
            filter
        );
    };

    getProductDocumentList = async (filter, top, orderby) => {
        return await new ProductDetailAPICall().getProductDocumentList(
            { filter, top, orderby }
        );
    };

    getAlternativeProductByVariantNumber = async (ItemNum, orderBy, top, skip) => {
        return await new ProductDetailAPICall().getAlternativeProductByVariantNumber(ItemNum, orderBy, top, skip);
    };

    getAlternativeProductCountByVariantNumber = async (ItemNum) => {
        return await new ProductDetailAPICall().getAlternativeProductCountByVariantNumber(ItemNum);
    };

    static detectStringIsItemNumber = (stringTEXT) => {
        let d = false;
        if (isString(stringTEXT)) {
            if (stringTEXT.includes('-')) {
                d = true;
            }
        }
        return d;
    };

    fetchSingleItemNumberByManufacturerPartNumber = async (manufacturerPartNumber) => {
        return await new ProductListingAPICall().getSingleItemNumberByManufacturerPartNumber(manufacturerPartNumber);
    };

    fetchSingleItemNumberBySearchParam = async (searchParam) => {
        return await new ProductListingAPICall().getSingleItemNumberBySearchParam(searchParam);
    };

    isCpnIsManualCPN = (single_product, selectedCPN) => {
        if (single_product?.CustomerPartNumbers?.length > 0) {
            if (single_product?.CustomerPartNumbers.filter(e => e.CPN === selectedCPN).length > 0) {
                return false;
            }
        }
        return true;
    }

    getProductPricingCPNOut = (single_product) => {
        if (single_product?.CustomerPartNumbers?.length > 0) {
            const itemPrice = single_product?.assets?.pricing;
            if (itemPrice && itemPrice.length > 0 && Helper.valueIsNotNull(itemPrice[0]?.customerPartNumberOut) === true)
                return itemPrice[0].customerPartNumberOut;
            else
                return single_product?.CustomerPartNumbers[0]?.CPN;
        }
        return "";
    }

    checkCPNAvailableInList = (cpnList, searchCPN) => {
        let selectedSearchCPN = cpnList?.find(
            (x) =>
                x?.CPN?.replace(/\s/g, "")?.toLowerCase() ==
                searchCPN?.replace(/\s/g, "")?.toLowerCase()
        );
        return selectedSearchCPN?.CPN ? selectedSearchCPN?.CPN : ''
    }

    getUniversalProductSearchList = async (searchParam) => {
        return new ProductListing().toObjectWithItemNumber(
            await new ProductListingAPICall().getUniversalProductSearchList(searchParam)
        );
    };
    getUniversalCategoryManufacturersSearchList = async (searchParam) => {
        let res = await new ProductListingAPICall().getUniversalCategoryManufacturersSearchList(searchParam);
        return res
    };

    // Get reference of attacthe Function 
    // you can use this function when same(duplicate)  part with the same CPN.
    getProductInventoryPriceWithCpn = async (objectInput, isInventoryCall = true, isPriceCall = true, currency = window.mct) => {
        let objectInputHere = [];
        if (_.isObject(objectInput) && Object.entries(objectInput).length > 0) {
            Object.entries(objectInput).map((v) => {
                let v_h = {
                    ERPPartNumber: v[1].ERPPartNumber ? v[1].ERPPartNumber : (v[1].ItemNumber ? v[1].ItemNumber : v[1].partNumber),
                    selectedCPN: v[1].customerPartNumber
                };
                objectInputHere.push(v_h);
            });
        } else if (_.isArray(objectInput) && objectInput.length > 0) {
            objectInput.map((v) => {
                let v_h = {
                    ERPPartNumber: v.ERPPartNumber ? v.ERPPartNumber : (v.ItemNumber ? v.ItemNumber : v.partNumber),
                    selectedCPN: v.customerPartNumber
                }
                objectInputHere.push(v_h);
            });
        }

        let p_w_a = await this.fetchProductObjectByERPPartNumbersNew(objectInputHere, false);

        let inventory = {}
        let pricing = {};

        // if (isInventoryCall === false && isPriceCall === false) {
        //     return p_w_a;
        // }

        let paramSet = [];
        if (isInventoryCall === true || isPriceCall === true) {

            if (isPriceCall === true) {
                const unique = (arr, props = []) => [...new Map(arr.map(entry => [props.map(k => entry[k]).join('|'), entry])).values()];
                let priceObj = unique(objectInputHere, ['ERPPartNumber', 'selectedCPN']);
                let params = [];
                if (priceObj && priceObj.length > 0) {
                    priceObj.map((v) => {
                        params.push({
                            partNumber: p_w_a[v.ERPPartNumber]?.ERPPartNumberModified ? '' : p_w_a[v.ERPPartNumber].ERPPartNumber,
                            erpManufacturerCode: p_w_a[v.ERPPartNumber].ERPManufacturerCode,
                            erpMfrPartNumber: p_w_a[v.ERPPartNumber].ERPMFRPartNumber,
                            WebCode: p_w_a[v.ERPPartNumber].WebCode,
                            ObsoleteFlag: p_w_a[v.ERPPartNumber].ObsoleteFlag,
                            customerPartNumber: v.selectedCPN,
                            currency: currency
                        })
                    });
                }
                paramSet = await new ProductPricingRepository().getPricingParams(params);
            }


            await Promise.all([
                new ProductInventoryRepository().fetchProductInventoryByProducts(p_w_a, true),
                new ProductPricingAPICall().getPricingNew(paramSet)
            ]).then((res) => {
                inventory = res[0];
                pricing = res[1];
            }).catch(() => { });

        }
        if (_.isArray(objectInput) && objectInput.length > 0) {
            objectInput.map((v) => {
                // let ele = v;
                this.setProductObj(v, p_w_a, inventory, pricing)
            });
        }

        if (_.isObject(objectInput) && Object.entries(objectInput).length > 0) {
            Object.entries(objectInput).map((v) => {
                this.setProductObj(v[1], p_w_a, inventory, pricing)
            });
        }

        return objectInput;
    };

    setProductObj = (inputObj, productList, inventory, pricing) => {
        let _productList = produceClone(productList);
        let ele = inputObj;
        let _productKey = ele.ERPPartNumber ? ele.ERPPartNumber : (ele.ItemNumber ? ele.ItemNumber : ele.partNumber)
        let _product = _productList[_productKey];

        if (_product) {
            _product.assets = {};
            _product.assets.inventory = inventory[_productKey] ? inventory[_productKey] : {
                qas: 0,
                quantity: 0
            };
            let partPrice = [];
            if (pricing && Object.entries(pricing).length > 0) {
                let _priceKey = _product.ERPPartNumberModified ? `${_product.ERPMFRPartNumber}-` : `${_product.ERPMFRPartNumber}-${_product?.ERPPartNumber}`;
                if (ele.customerPartNumber) {
                    _priceKey = `${_priceKey}-${Helper.toUpperCase(ele.customerPartNumber)}`;
                }

                let _pricing = pricing[_priceKey]

                if (_pricing && _pricing?.prices && _pricing?.prices?.length > 0) {
                    const _parentPrice = {
                        "partNumber": _pricing.partNumber,
                        "erpManufacturerCode": _pricing.erpManufacturerCode,
                        "customerPartNumber": _pricing.customerPartNumber,
                        "customerPartNumberOut": _pricing.customerPartNumberOut,
                        "erpMfrPartNumber": _pricing.erpMfrPartNumber,
                        "originalLine": _pricing.originalLine,
                        "currency": _pricing.currency,
                        "currIND": _pricing.currIND,
                        "salesOrg": _pricing.salesOrg,
                        "message": _pricing.message,
                        "error": _pricing.error
                    };

                    _pricing.prices.map((p, j) => {
                        let _price = { ..._parentPrice, ...p };
                        partPrice.push(_price)
                    })
                }
                // _pricing = partPrice;
            }
            _product.assets.pricing = partPrice;
            ele.product = _product;
            return ele;
        }
        return ele;
    }
};

export default ProductRepository;